<ng-container bbTransactionSigningInterfaceCustomizable
              [bbHostRef]="hostRef"></ng-container>

<ng-template bbTransactionSigningInterfaceCustomizable
             let-hostRef>
  <bb-modal-ui [isOpen]="true"
               [modalOptions]="hostRef.modalOptions">
    <bb-modal-header-ui data-role="ts-modal">
      <ng-template bbCustomModalHeader>
        <bb-transaction-signing-header [data]="hostRef.transactionData"></bb-transaction-signing-header>
      </ng-template>
    </bb-modal-header-ui>
    <bb-modal-body-ui>
      <ng-template bbCustomModalBody>
        <hr class="mt-0" />
        <bb-transaction-signing-action-pending *ngIf="hostRef.isPending"></bb-transaction-signing-action-pending>
        <ng-container *ngIf="!hostRef.isPending">
          <bb-transaction-signing-error *ngIf="hostRef.challengeError"
                                        [error]="hostRef.challengeError"
                                        (close)="hostRef.failure.emit($event)">
          </bb-transaction-signing-error>
          <bb-transaction-signing-hard-token *ngIf="hostRef.isChallengeType('hard-token-auth')"
                                             [data]="hostRef.challengeData"
                                             [error]="hostRef.error"
                                             (complete)="hostRef.post.emit($event)"
                                             (cancel)="hostRef.post.emit({ responseType: 'confirmation-abort' })"
                                             (acceptError)="hostRef.failure.emit($event)">
          </bb-transaction-signing-hard-token>
          <bb-transaction-signing-oob-select-device *ngIf="hostRef.isChallengeType('oob-ts-select-device')"
                                                    [data]="hostRef.challengeData"
                                                    [error]="hostRef.error"
                                                    (complete)="hostRef.post.emit($event)"
                                                    (cancel)="hostRef.post.emit({ responseType: 'confirmation-abort' })"
                                                    (acceptError)="hostRef.failure.emit($event)">
          </bb-transaction-signing-oob-select-device>
          <bb-transaction-signing-oob-device *ngIf="hostRef.isChallengeType('oob-uaf-auth')"
                                             [data]="hostRef.challengeData"
                                             [enableResendPushNotification]="hostRef.enableResendPushNotification"
                                             [error]="hostRef.error"
                                             (poll)="hostRef.poll.emit({ responseType: 'system-poll' })"
                                             (cancel)="hostRef.post.emit({ responseType: 'confirmation-abort' })"
                                             (acceptError)="hostRef.failure.emit($event)"
                                             (resend)="hostRef.post.emit({ responseType: 'pn-resend' })">
          </bb-transaction-signing-oob-device>
          <bb-transaction-signing-sms-otp *ngIf="hostRef.isChallengeType('sms-otp-auth')"
                                          [data]="hostRef.challengeData"
                                          [previousData]="hostRef.previousChallengeData"
                                          [error]="hostRef.error"
                                          (complete)="hostRef.post.emit($event)"
                                          (cancel)="hostRef.post.emit({ responseType: 'confirmation-abort' })"
                                          (acceptError)="hostRef.failure.emit($event)"
                                          (resend)="hostRef.post.emit({ responseType: 'otp-resend' })">
          </bb-transaction-signing-sms-otp>
<!--          <bn-otp-web *ngIf="hostRef.isChallengeType('banesco-otp-web') || true"></bn-otp-web>-->

        </ng-container>
      </ng-template>
    </bb-modal-body-ui>
  </bb-modal-ui>
</ng-template>
